<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pa-0">
        <ComplianceHeader />
      </v-col>
      <v-col cols="12" class="pa-0" style="height: fit-content">
        <img
          src="@/assets/banner_compliance_1920x783px.webp"
          alt="Banner Hospital Cassems Campo Grande"
          class="banner-img"
          width="100%"
          height="50%"
        >
      </v-col>
      <v-col cols="11" class="mx-auto pa-2 my-4">
        <h1>Compliance</h1>
        <p class="mt-2">
          Sejam muito bem-vindos à página do nosso Programa de Integridade!
        </p>
        <p class="mt-2">
          Aqui vocês encontrarão informações detalhadas sobre o programa, nosso
          Código de Conduta e vídeos explicativos para facilitar a compreensão.
        </p>
        <p class="mt-2">
          Lembrem-se: um Programa de Integridade efetivo se constrói com a
          participação e o comprometimento de cada um. Explorem o conteúdo e
          façam parte desta importante iniciativa!
        </p>
      </v-col>

      <v-col cols="12" class="pa-0 bg-primary text-white py-4">
        <v-col cols="11" class="mx-auto pa-2 mb-10">
          <h1>Categorias</h1>

          <div
            v-if="complianceCategories.length === 0"
            class="my-8 text-center"
          >
            <h2>Nenhuma categoria encontrada.</h2>
          </div>

          <v-row v-else class="container-card">
            <v-col
              v-for="category in complianceCategories"
              :key="'category-' + category.id"
              class="card"
            >
              <img
                :src="category.featuredImage || defaultImage"
                alt="Imagem da Categoria"
                style="border-radius: 5px"
                width="100%"
                height="180px"
              >
              <h2 class="my-4">
                {{ category.title }}
              </h2>

              <div style="flex-grow: 1" />

              <router-link
                class="custom-btn"
                :to="`${
                  redirectToExternalPage() ? '/external' : ''
                }/compliance/category/${category.id}`"
              >
                <div class="custom-btn-bg">
                  <v-icon color="#173c93" size="25px">
                    mdi-arrow-right
                  </v-icon>
                </div>
                <p class="custom-btn-text">
                  Visualizar
                </p>
              </router-link>
            </v-col>
          </v-row>
        </v-col>
      </v-col>

      <v-col cols="12" class="pa-0">
        <ComplianceFooter />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AllCategory } from "../services/compliance-category-service";
import ComplianceFooter from "@/components/Compliance/ComplianceFooter.vue";
import ComplianceHeader from "@/components/Compliance/ComplianceHeader.vue";
import DefaultImage from "@/assets/compliance-default.webp";

export default {
  name: "ComplianceGrid",
  components: {
    ComplianceHeader: ComplianceHeader,
    ComplianceFooter: ComplianceFooter,
  },
  data: () => ({
    defaultImage: DefaultImage,
    complianceCategories: [],
  }),

  async created() {
    this.complianceCategories = await AllCategory();
  },

  methods: {
    redirectToExternalPage() {
      return this.$route.name && this.$route.name.startsWith("external");
    },
  },
};
</script>

<style scoped>
.banner-img {
  max-height: 70vh;
}
</style>
